import * as React from "react";
import * as _ from 'lodash';
import moment from "moment";
import {useParams} from "react-router-dom";
import {
    Box,
    Grid,
    IconButton,
    Button,
    ButtonGroup,
    FormControl,
    Select,
    MenuItem,
    FormLabel,
    TextField,
    Typography,
} from '@mui/material';
import {loadPatientById, patient} from '../../store/reducers/patient';
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import AdmissionSection from "./admissionSection";
import {AgyleLogoIcon, BackIcon} from '../../components/icons/icons';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SendIcon from '@mui/icons-material/Send';
import { useHistory } from "react-router-dom";
import PatientHelper from "../../controls/helpers/patientHelper";
import {additionalData, loadPatientAdditionalData, setLoading} from '../../store/reducers/additionalData';
import {
    hasBAPermission,
    hasOneOfPermission,
    hasPermission,
    isBaAdmin,
    Permissions,
    user,
} from '../../store/reducers/user';
import {ToggleRadioNamed} from "./components";
import {demographicSchema, FromDemographicsSection} from "./demographicsSection";
import {basicInformationSchema, BasicInformationSection} from "./basicInformationsSection";
import {proceduresSchema, FromProceduresSection, ProcedureItem, procedureEditSchema} from './proceduresSection';
import {clinicalTeamNotesSchema, ClinicalTeamNotesSection, referralNotesSchema, ReferralNotesSection} from "./referalNotesSection";
import DatePicker from "@mui/lab/DatePicker";
import API from "../../app/api";
import {
    getAdmissionConfig,
    getConfig, getMarkedOperation,
    reload,
    setMarkedOperation, setNewAdmissionType, setNewView,
    setOperationsStatus, setOperationToScroll, setSelectedTheatre, setTheatreById,
} from '../../store/reducers/booked_admissions';
import {useEffect, useState} from 'react';
import {setSnackbar} from '../../store/reducers/globals';
import {AdmissionConsultant} from '../../controls/agyle/dictionaries';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PatientAlertsComponent from './patientAlertsComponent';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import {
    admissionStatusTypes,
    admissionViewTypes,
    bookAdmissionToggleStyles,
    CalendarViews,
} from '../bookedAdmissions/bookedAdmissions';
import PrintIcon from '@mui/icons-material/Print';
import useOpenState from '../../hooks/useOpenState';
import {HeaderPrintModal} from '../bookedAdmissions/header/bookedAdmissionsHeader';
import APIForm from '../../app/apiForm';
import AgyleToggleButtons from '../../components/ui/buttons/agyleToggleButtons';
import clsx from 'clsx';
import config from '../../app/config';
import {Tooltip} from '@material-ui/core';
import {agylePref} from '../../store/reducers/preferences';

const useStyles = makeStyles((theme) => ({
    header: {
        height: "57px",
        padding: "12px 10px",
    },
    headerLeft: {
        height: "100%",
        display: "flex",
        flexDirection: "row"
    },
    headerRight: {
        height: "100%",
        display: "flex",
        flexDirection: "row-reverse"
    },
    subHeader:{
        height: "64px",
        border: "0px solid red",
        paddingLeft: "5px",
        paddingRight: "10px",
        marginTop: 5,
        display: "flex",
        alignItems: "flex-end",
        marginBottom: "20px"
    },
    arrowIcon: {
        marginLeft: "10px",
        marginRight: "10px",
        marginTop: "6px",
        width: "18px",
        height: "18px"
    },
    appLogo: {
        width: "30px",
        height: "30px"
    },
    patientName: {
        display: "inline-flex",
        lineHeight: "30px",
    },
    patientFamilyName: {
        textTransform:"uppercase"
    },
    patientBadge: {
        display: "inline-flex",
        backgroundColor: theme.palette.background.patientBadge,
        borderRadius: "5px",
        padding: "3px 16px 4px"
    },
    patientBadgeItem: {
        marginRight: "15px",
    },
    badgeLabel: {
        fontSize: "0.755rem",
        fontWeight: 200
    },
    badgeValue: {
        fontSize: "0.725rem",
        fontWeight: 700
    },
    overseeingConsultant: {
        "& .MuiInputLabel-root": {
            top: "-8px"
        },
        "& .MuiAutocomplete-inputRoot": {
            paddingBottom: "0px",
            paddingTop: "0px",
        }
    },
    formTypeButton: {
        width: "120px",
        display: "inline-block",
        textAlign: "center",
        margin: "4px 4px",
        backgroundColor: theme.palette.background.paperDarker,
        color: theme.palette.admissionForm.labelColor,
        borderRadius: "4px",
        padding: "3px 0px",
        cursor: "pointer"
    },
    dcLabel: {
        display: "inline-block",
        position: "relative",
        top: "3px",
        fontSize: "14px",
        background: theme.palette.bookAdmissions.dcLabelBackground,
        padding: "6px 10px",
        borderRadius: "6px",
        fontWeight: 700

    },
    alert: {
        padding: "10px",
        borderBottom: "1px solid black",
    },
    alertType: {
        textAlign: "center"
    },
    alertGroup: {
        fontWeight: "bold",
        paddingTop: "10px"
    },
    alertBoldText: {
        fontWeight: "bold"
    },
    alertText: {
        paddingTop: "10px"
    },
    button: {
        //float: "right"
    },
    scheduleSlots: {
        background: theme.palette.bookAdmissions.dcLabelBackground,
        color: theme.palette.bookAdmissions.timelineText,
        margin: 5,
        padding: 12,
        borderRadius: 5
    },
    historyItem: {
        width: 180,
        height: 57,
        background: "#3D3E40",
        borderRadius: 8,
        padding: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        margin: 5,
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: theme.palette.bookAdmissions.timelineBackground,
        color: theme.palette.bookAdmissions.timelineText,
        "&.selected" : {
            backgroundColor: theme.palette.bookAdmissions.timelineBackgroundSelected,
            color: theme.palette.bookAdmissions.timelineTextSelected,
        }
    },
    historyViewBanner: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    historyViewControls: {
        display: "flex", alignItems: "center"
    },
    historyItemLength: {
        padding: "5px",
        minWidth: "29px",
        background: theme.palette.bookAdmissions.timelineBackground,
        color: theme.palette.bookAdmissions.timelineText,
        textAlign: "center",
        marginRight: "5px",
        borderRadius: "5px",
        height: "29px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
}));

export const useStylesInputControls = makeStyles((theme) => ({
    label: {
        color: theme.palette.admissionForm.labelColor,
        lineHeight: "32px",
        fontWeight: "500",
        fontSize: "0.95rem",
    },
    notesInput: {
        backgroundColor: theme.palette.background.paperDarker,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    },
    notesInputModal: {
        backgroundColor: theme.palette.admissionForm.backgroundNotes,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    }
}));

const patientBadgeItems = [
    {
        item: "born",
        toDisplay: "Born",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientDob(data.patient) : "";
        }
    },
    {
        item: "age",
        toDisplay: "Age",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientAge(data.patient) : "";
        }
    },
    {
        item: "gender",
        toDisplay: "Gender",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientGender(data.patient) : "";
        }
    },
    {
        item: "hospital",
        toDisplay: "Hos No",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientHospitalNumber(data.patient) : "";
        }
    },
    {
        item: "nhs",
        toDisplay: "NHS No",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientNSHNumber(data.patient) : "";
        }
    },
    {
        item: "bed",
        toDisplay: "Bed",
        value: (data) => {
            return data.patientBed;
        }
    },
]

const baseAdmissionData = {
    _createdDate: null,
    _createdBy: "",
    opType: "TCI",
    status: "WORKLIST"
}

export const notesSchema = {
    notes: "",
    procedureNotes: "",
    overseeingConsultant: null
}

const personCompletingRecordSchema = {
    personCompRecord: {
        personCompleting: null,
        role: null,
        recordCompleted: null
    }
    //mtu - record competing

}

export function BookAdmissionForm(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const inputClasses = useStylesInputControls();
    const baToggleClasses = bookAdmissionToggleStyles();
    const {t} = useTranslation();
    const itemsFormTypes = [
        {code: "TCI", description: t("Theatres")},
        {code: "MDU", description: t("MDU")}
    ]
    const {patientId} = useParams();
    const {operationId} = useParams();
    const patientObject = useSelector(patient);
    const userObject = useSelector(user);
    const patientAdditionalDataObject = useSelector(additionalData);
    const [patientBadgeData, setPatientBadgeData] = React.useState(null);
    const history = useHistory();
    const [admission, setAdmission] = React.useState(Object.assign({}, _.cloneDeep(baseAdmissionData),
                                            _.cloneDeep(demographicSchema), _.cloneDeep(basicInformationSchema),
                                            _.cloneDeep(notesSchema)));
    const [admissionTMP, setAdmissionTmp] = React.useState(null);

    const dictionaries = useSelector(getConfig);
    const [procedures, setProcedures] = React.useState([]);
    const [consultants, setConsultants] = React.useState([]);

    const [disabledSave, setDisabledSave] = React.useState(true);
    const [editView, setEditView] = React.useState(false);
    const [disableFields, setDisabledFields] = useState(false);
    //const [historyView] = useState(false);

    const historyView = props.historyView;

    const [isPrintModalOpen, openPrintModal, closePrintModal] = useOpenState(false, true);


    const oldSysType = React.useRef(null);
    const oldConsultant = React.useRef(null);


    useEffect(()=>{
        if(props.transfer) {
            handleAdmissionChangeType(itemsFormTypes[0])
        }
    },[props.transfer])

    const agylePreference = useSelector(agylePref);
    const configBA = useSelector(getConfig);

    useEffect(()=>{
        if(!disableFields && configBA && agylePreference?.loadedFromApi){
            if(agylePreference.bookedAdmissions.defaultFormAdmissionType) {
                handleAdmissionChangeType(agylePreference.bookedAdmissions.defaultFormAdmissionType);
            } else if(configBA.defaultFormAdmissionType) {
                handleAdmissionChangeType(configBA.defaultFormAdmissionType);
            }
        }
    },[agylePreference, configBA])

    const proceduresAreValid = () => {
        return admission.procedures && admission.procedures?.length > 0 && admission.procedures[0] &&
                admission.proceduresLen?.length > 0 && admission.procedures?.length === admission.proceduresLen?.length &&
                !admission.proceduresLen?.some((len) => len === 0)
    }


    const validation = () => {
        let isValid = true;

        if(admission.opType === admissionViewTypes.THEATRES &&
            (!admission.patientType || !proceduresAreValid() || !admission.overseeingConsultant || !admission.phone
                || !admission.transportType || !admission.priority || !admission.anaestheticType || !admission.whoCouldOperate)) {

            isValid = false;
        }

        if(admission.opType === admissionViewTypes.MDU && !proceduresAreValid()) isValid = false;

        if(!editView && isValid) {
            let permissionToCheck = admissionViewTypes.THEATRES === admission.opType? Permissions.BA_CAN_MANAGE_T_ADMISSIONS: Permissions.BA_CAN_MANAGE_MDU_ADMISSIONS;
            isValid = dispatch(hasBAPermission(permissionToCheck, admission.opType))
        }

        setDisabledSave(!isValid);
    }

    const checkAdmissionData = () => {

            if(!oldSysType.current) oldSysType.current = admission.patientType?.systype;
            if(oldSysType.current !== admission.patientType?.systype && !historyView) {
                oldSysType.current = admission.patientType?.systype;
                testProcedureForSysType()
            }

            if(admission.overseeingConsultant === null) oldConsultant.current = null;
            if(admission.overseeingConsultant &&
                (!oldConsultant.current || oldConsultant.current?.id !== admission.overseeingConsultant?.id)) {

                console.log("test procedure - overseeingConsultant")
                oldConsultant.current = admission.overseeingConsultant;
                testProcedureForConsultant()
            }

    }

    let signalProcedures = new AbortController();

    useEffect(()=>{
        if(!_.isEmpty(userObject) && !dispatch(hasPermission(Permissions.BA_CAN_ACCESS_BA))){
            history.push("/");
        }
    },[userObject]);

    useEffect(()=>{
        validation();
        reloadConsultant();
        if(!disableFields && !admission.bookedSession) checkAdmissionData()
    },[admission])

    const reloadConsultant = () => {
        if(admission.overseeingConsultant && !admission.overseeingConsultant.procedures) {
            let filter = admission.overseeingConsultant.name.split(" ")

            API.getDictByURL(`/admission/person/consultant?filter=${filter[filter.length-1]}&pageSize=100&page=1`, signalProcedures.signal).then(consultants => {
                consultants.forEach((c) => {
                    if(c.id === admission.overseeingConsultant.id) {
                        handleAdmissionChange("overseeingConsultant", c)
                    }
                })});
        }
    }

    const testProcedureForSysType = () => {
        if(admission.procedures) {
            setAdmission((ad) => {
                let proceduresTmp = [...ad.procedures];
                let proceduresLenTmp = [...ad.proceduresLen];

                proceduresTmp.forEach((procedure,index) => {
                    let durationSys =  _.find(procedure?.systype, {"code": admission.patientType?.systype});
                    if (durationSys){
                        if(proceduresLenTmp[index] !== durationSys.duration) {
                            //not
                        }
                        proceduresLenTmp[index] = durationSys.duration
                    } else {
                        delete proceduresTmp.splice(index, 1);
                        delete proceduresLenTmp.splice(index, 1);
                    }
                })
                return {
                    ...ad,
                    procedures: proceduresTmp,
                    proceduresLen: proceduresLenTmp
                }

            })
        }

    }

    const testProcedureForConsultant = () => {
        if(admission.procedures) {
            setAdmission((ad) => {
                let proceduresTmp = [...ad.procedures];
                let proceduresLenTmp = [...ad.proceduresLen];

                let newProcedures = [];
                let newProceduresLen = [];

                proceduresTmp.forEach((procedure,index) => {
                    if(procedure) {
                        let procOnList =  admission.overseeingConsultant?.procedures?.some((p) => p === procedure?.__id);//__.find(admission.overseeingConsultant?.procedures, procedure?.__id);
                        if (procOnList){
                            newProcedures.push(procedure);
                            newProceduresLen.push(proceduresLenTmp[index])
                        }
                    } else {
                        newProcedures.push(null);
                        newProceduresLen.push(null)
                    }

                })

                return {
                    ...ad,
                    procedures: newProcedures,
                    proceduresLen: newProceduresLen
                }

            })
        }

    }

    const loadOperation = () => {
        let filter = `_id eq_id '${operationId}'`;
        API.getOperation(filter)
            .then(operations => {
                handleAdmissionChangeType(operations[0].opType)

                setAdmission((ad) => {
                    return {
                        ...ad,
                        ...operations[0]
                    }
                })
            })
            .catch(error => {
                // TODO: error handler !!!
                console.error(error);
            });
    }

    useEffect(()=>{
        if(props.operation) {

           // setHistoryView(false);
            setAdmissionTmp(null);
            setHistoryItemIndex(null);

            oldSysType.current = null;
            oldConsultant.current = null;
            procedureLenOld.current = null;

            setEditView(true);
            setDisabledFields(true);

            if(props.operation.patientId) {
                try{
                    dispatch(loadPatientById(props.operation.patientId));
                    dispatch(loadPatientAdditionalData(props.operation.patientId));
                    handleAdmissionChangeType(props.operation.opType)
                } catch (e) {
                    dispatch(setLoading(undefined));
                    console.log("error")
                }
            }

            setAdmission((ad) => {
                return {
                    ...props.operation
                }
            })
        }
    }, [props.operation])

    React.useEffect(()=> {

        if(operationId && operationId !== "new") {
            setEditView(true);
            setDisabledFields(true);
            loadOperation();
        }

        if(patientId){
            //console.log("dispatch use effect",patientId , patientObject);
            dispatch(loadPatientById(patientId.replace("_$_","/")));
            dispatch(loadPatientAdditionalData(patientId.replace("_$_","/")));
        }

        let signalConfig = new AbortController();
        let signalProcedures = new AbortController();
        let signalConsultants = new AbortController();

        if(!dictionaries) dispatch(getAdmissionConfig());

        API.getConsultants(signalConsultants.signal, `AND bookAdmissionRoles_itemArrays.code eq 'OC'`).then(consultants => {
            setConsultants(consultants.__data);
        })
        API.getDictByURL("/$dict/Procedures", signalProcedures.signal).then(procedures => {
            setProcedures(procedures.__data);
        })
        return  ()=> {
            signalConfig.abort()
            signalProcedures.abort();
        }
    },[]);

    React.useEffect(() => {
        if(!props.operation && !historyView) {
            let tmpAdmission = {};
            if(patientObject){
                setPatientBadgeData(generateBadgeElements({patient: patientObject, patientBed: "--"}));
                tmpAdmission.patientId = patientObject.hospitalNumber;
                tmpAdmission.phone = admission.phone? admission.phone : (patientObject.mobilePhone? patientObject.mobilePhone: patientObject.homePhone? patientObject.homePhone: "");
                tmpAdmission.patientName = (patientObject.familyName ? patientObject.familyName : "");
                tmpAdmission.patientName += (patientObject.firstName ? ", " + patientObject.firstName : "");
                tmpAdmission.patientName += (patientObject.middleNames ? " " + patientObject.middleNames : "");
                tmpAdmission.patientDob = patientObject.dob;
            } else {
                setPatientBadgeData(null);
            }
            if(userObject && operationId === "new"){
                tmpAdmission._createdBy = userObject.userName;
                tmpAdmission._createdDate = moment();
            }
            setAdmission((ad) => {
                return {
                    ...ad,
                    ...tmpAdmission
                }
            });

            // //console.log("userObject", userObject);
            // //console.log("patientObject", patientObject);
            // //console.log("patientAdditionalDataObject", patientAdditionalDataObject);
        } else {

        }


    }, [patientObject, patientAdditionalDataObject, userObject]);



    const goBack = () => {
        history.push("/bookedAdmissions");
    }

    const generateBadgeElements = (data) => {
        let elements = [];
        patientBadgeItems.map((badgeItem) => {
            let v = badgeItem.value(data);
            elements.push(
                <div className={classes.patientBadgeItem} key={badgeItem.item}>
                    <span className={classes.badgeLabel}>
                        {t(badgeItem.toDisplay)}
                    </span>:&nbsp;
                    <span className={classes.badgeValue}>
                        {v}
                    </span>
                </div>
            )
        });
        return (
            <React.Fragment>
                {elements}
            </React.Fragment>
        )
    }

    const handleAdmissionChangeType = (opType) => {
        //change opType
        setASelectedSessionToAdd(null);

        let tmpAdmission = _.cloneDeep(admission);
        let keyToDelete = [];
        if(opType.code === "TCI" && admission.opType !== opType) {
            //basicInformationSchema, procedures to empty array
            keyToDelete.push(...Object.keys((Object.assign({procedureMDU: null}, referralNotesSchema, clinicalTeamNotesSchema, personCompletingRecordSchema))));
            Object.assign(tmpAdmission, _.cloneDeep(basicInformationSchema), _.cloneDeep(notesSchema));
        }
        if(opType.code === "MDU" && admission.opType !== opType) {
            //referralNotesSchema, clinicalTeamNotesSchema, procedures to empty array
            keyToDelete.push(...Object.keys((Object.assign({}, basicInformationSchema, notesSchema))));
            Object.assign(tmpAdmission, _.cloneDeep(referralNotesSchema), _.cloneDeep(clinicalTeamNotesSchema), _.cloneDeep(personCompletingRecordSchema, {procedureMDU: _.cloneDeep(procedureEditSchema)}));
        }
        _.forEach(keyToDelete, (key) => {
            delete tmpAdmission[key];
        });
        Object.assign(tmpAdmission, _.cloneDeep(proceduresSchema));
        tmpAdmission.opType = opType.code;
        tmpAdmission.status = opType.code === "TCI"? "WORKLIST": "PENDING";
        setAdmission(tmpAdmission);
    }

    const handleAdmissionChange = (property, value) => {
       // let adm = _.cloneDeep(admission);

       // console.log("handleAdmissionChange", property, value, "new admission obj", adm);
        setAdmission((ad) => {
            let adm = _.cloneDeep(ad);
            if(property === "multiChange" && Array.isArray(value)){
                value.forEach(item => {
                    adm[item[0]] = item[1];
                })
            } else {
                _.set(adm, property, value)
            }
            return adm;
        });
    }

    const [iFrameView, setIFrameView] = React.useState(false);

    useEffect(()=>{
        let params = new URLSearchParams(window.location.search);
        let view = params.get("view");
        if(view === "admissions_iframe" || view === "admissions_patient_iframe")
            setIFrameView(true)
    },[])


    const handleSubmitAdmission = () => {

            let signalSubmit = new AbortController();
            let tmpA = _.cloneDeep(admission);

            tmpA.consultant = tmpA.consultant != null && tmpA.consultant.hasOwnProperty("item") ? tmpA.consultant.item : tmpA.consultant;

            let patientTmp = tmpA["patient"];
            let sessiosObjTmp = tmpA["sessiosObj"];

            delete tmpA["href"];
            delete tmpA["patient"];
            delete tmpA["type"];
            delete tmpA["sessiosObj"];


            if(tmpA['status'] === "SEND") {
                tmpA['status'] = "PENDING"
            } else if(selectedSessionToAdd || addToList){
                tmpA['status'] = "WORKLIST_AND_CALENDAR";
            }


            if(tmpA.overseeingConsultant) {
                tmpA.overseeingConsultant = {
                    id: tmpA.overseeingConsultant.id,
                    name: tmpA.overseeingConsultant.name,
                }
            }

            API.admissionUpdate(tmpA, signalSubmit.signal).then(
                (operation) => {
                    dispatch(setMarkedOperation({
                        ...operation,
                        patient: patientTmp || patientObject,
                        sessiosObj: sessiosObjTmp
                    }));

                    // if(!iFrameView)
                    dispatch(reload());

                    setEditView(true);
                    setDisabledFields(true);
                    setAdmission(operation);

                    dispatch(setSnackbar({
                        type: "success",
                        message: "Form Submitted",
                    }));

                    if(operation.endSurgery) {
                        let pData = {
                            name: operation.patientName,
                            nhs: operation.patientId,
                            hospital: operation.patientId,
                            dob: operation.patientDob
                        }

                        let data = {
                            operation: {
                                ...operation,
                                patient: patientTmp
                            },
                            ...pData
                        }

                        let formName = operation.opType === "MDU"? "surgeryMDU": "surgery";

                        APIForm.getSaveForm( {data: data} , operation.patientId, formName)
                            .then((response)=>{
                                    dispatch(setSnackbar({type: "success", message: "Dor genereted"}));
                                    return !!response;
                                },
                                (er)=> {
                                    return false
                                }
                            );

                    }
                    if(selectedSessionToAdd && !operation.bookedSession) {
                        let timeToAdd = operation.proceduresLen?.reduce((accumulator, time) => accumulator + time, 0) || 0;
                        let data = {
                            theatreSessionId: selectedSessionToAdd.session.id,
                            time: moment(selectedSessionToAdd.time).utc().format("HH:mm"),
                            operationId: operation.id,
                            workStationId: selectedSessionToAdd.stationID,
                            opTimeLen: timeToAdd,
                        }

                        API.theatreSessionsAddOperation(data).then(session => {

                            reloadOperationAndSetSession(operation.id, session);
                          //  dispatch(setMarkedOperation(null))
                            //dispatch(reload());

                            dispatch(setSnackbar({
                                type: "success",
                                message: "Operation added to Session",
                            }));

                        }).catch(function (error) {
                            // TODO: error handler !!!
                            dispatch(setSnackbar({
                                type: "error",
                                message: "Operation not added to Session",
                            }));
                            console.error(error);
                        });
                    } else {
                        //if(!iFrameView) history.push("/bookedAdmissions");
                    }

                }
            ).catch(error => {
                dispatch(setSnackbar({
                    type: "error",
                    message: error.message,
                }));
            });


    }


    const reloadOperationAndSetSession = (id, session) =>{
        let filter = `_id eq_id '${id}'`;
        API.getOperation(filter)
            .then(operations => {
                setAdmission(operations[0]);

              //  console.log(session);

                dispatch(setMarkedOperation({
                    ...operations[0],
                    patient: patientObject,
                    sessiosObj: session
                }));

                dispatch(setOperationToScroll(operations[0].id));
                dispatch(setOperationsStatus(admissionStatusTypes.SCHEDULED))

                dispatch(setTheatreById(session.theatre.__id))
                dispatch(setNewView(moment(session.day), CalendarViews.days1));
                dispatch(reload());

            })
            .catch(error => {
                // TODO: error handler !!!
                console.error(error);
            });
    }

    const reloadOperation = () => {
        let filter = `_id eq_id '${admission.id}'`;
        API.getOperation(filter)
            .then(operations => {
                setDisabledFields(true);
                setAdmission(operations[0]);
                setASelectedSessionToAdd(null);
                dispatch(setMarkedOperation(operations[0]));
            })
            .catch(error => {
                // TODO: error handler !!!
                console.error(error);
            });
    }

    const handleProcedureChange = (type, itemIdx, proc, time) => {
      //  console.log(type, itemIdx, proc, time);

        switch(type) {
            case "update": {
                setAdmission((ad)=>{
                    let proceduresTmp = ad.procedures? [...ad.procedures] : [];
                    proceduresTmp[itemIdx] = _.cloneDeep(proc)
                    return {
                        ...ad,
                        procedures: proceduresTmp
                    }
                });

                break;
            }
            case "update_time": {
                setAdmission((ad)=>{
                    let proceduresLenTmp = ad.proceduresLen? [...ad.proceduresLen] : [];
                    proceduresLenTmp[itemIdx] = time
                    return {
                        ...ad,
                        proceduresLen: proceduresLenTmp
                    }
                });

                break;
            }
            case "add_proc": {
                setAdmission((ad)=>{
                    let proceduresTmp = ad.procedures? [...ad.procedures] : [];
                    let proceduresLenTmp = ad.proceduresLen? [...ad.proceduresLen] : [];

                    proceduresTmp.push(null)
                    proceduresLenTmp.push(null)

                    return {
                        ...ad,
                        procedures: proceduresTmp,
                        proceduresLen: proceduresLenTmp
                    }
                });

                break;
            }
            case "remove_proc": {
                setAdmission((ad)=>{

                    let proceduresTmp = [...ad.procedures];
                    proceduresTmp.splice(itemIdx, 1)

                    let proceduresLenTmp = [...ad.proceduresLen];
                    proceduresLenTmp.splice(itemIdx, 1)

                    return {
                        ...ad,
                        procedures: proceduresTmp,
                        proceduresLen: proceduresLenTmp
                    }
                });

                break;
            }
            default: {

            }
        }
    }

    const procedureLenOld = React.useRef(null);

    const userCanScheduleDirectly = dispatch(hasBAPermission(Permissions.BA_CAN_SCHEDULE_DIRECTLY, admission.opType));

    useEffect(()=>{

        const getSlots = setTimeout(() => {
            if((!procedureLenOld.current || !_.isEqual(procedureLenOld.current, admission.proceduresLen)) && userCanScheduleDirectly) {
                procedureLenOld.current = admission.proceduresLen;
                if(admission && admission.opType && admission.procedures && !admission.procedures.some((p) => p === null)) {
                    generateFreeSlots();
                }
            }
        }, 1000)


        return () => clearTimeout(getSlots)

    },[admission])



    const renderFreeSlots = (sessions) => {
        if(admission.opType === "TCI") renderFreeSlotsTCI(sessions);
        else renderFreeSlotsMDU(sessions)
    }

   const renderFreeSlotsMDU = (sessions) => {
       let slots = [];
       sessions?.forEach((session) => {


           let allWorkStations = {};

           session.workStations?.forEach((workStation) => {
               if(!allWorkStations[workStation.id]) allWorkStations[workStation.id] = workStation
           })

           Object.keys(allWorkStations).forEach((stationID) => {
               let sessionStartHour = moment(session.day);

               let sessionMaxTime = session.maxTime;
               let sessionEndHour = moment(session.day).add(sessionMaxTime, "minutes");
               let timeToAdd = admission.proceduresLen?.reduce((accumulator, time) => accumulator + time, 0) || 0;
               let hourStart = moment(sessionStartHour);
               //let sorted  = session.bookedSessions.sort(function(x, y){ return x.startTime > y.startTime? 1: -1;});

               let sorted = session.bookedSessions.filter((bookedSession) => {
                   if(bookedSession.workStationId === stationID)
                       return bookedSession
               })
               sorted = _.sortBy(sorted, ses => {
                   return ses.startTime; //props.data[ses.operationId]?.bookedDate ||
               });

               sorted.forEach((op, index) => {
                   let opStartTime = moment(op.startTime);
                   let opEndTime = moment(opStartTime).add(op.timeLen, "minutes");

                   if(opStartTime.diff(hourStart, "minutes") >= timeToAdd ){
                       slots.push({
                           stationID: stationID,
                           session: session,
                           start: hourStart,
                           end: opStartTime.format("HH:mm"),
                           len: opStartTime.diff(hourStart, "minutes")
                       })
                   }

                   hourStart =  opEndTime;

               });

             //  console.log(sorted);
              // if(sorted.length === 0) {
                   if(sessionEndHour.diff(moment(hourStart), 'minutes') >= timeToAdd){
                       slots.push({
                           stationID: stationID,
                           session: session,
                           start: hourStart,
                           len: sessionMaxTime
                       })
                   }
              // }
           })

       })

    //   console.log(slots);
       setSlots(slots)
   }

    const renderFreeSlotsTCI = (sessions) => {
        let slots = [];
        sessions?.forEach((session) => {

                let sessionStartHour = moment(session.day);

                let sessionMaxTime = session.maxTime;
                let sessionEndHour = moment(session.day).add(sessionMaxTime, "minutes");
                let timeToAdd = admission.proceduresLen?.reduce((accumulator, time) => accumulator + time, 0) || 0;
                let hourStart = moment(sessionStartHour);
                let sorted  = session.bookedSessions.sort(function(x, y){ return x.startTime > y.startTime? 1: -1;});


                sorted.forEach((op, index) => {
                    let opStartTime = moment(op.startTime);
                    let opEndTime = moment(opStartTime).add(op.timeLen, "minutes");

                    if(opStartTime.diff(hourStart, "minutes") >= timeToAdd ){
                        slots.push({
                            session: session,
                            start: hourStart,
                            end: opStartTime.format("HH:mm"),
                            len: opStartTime.diff(hourStart, "minutes")
                        })
                    }

                    hourStart =  opEndTime;

                });

              //  if(slots.length === 0) {
                    if(sessionEndHour.diff(moment(hourStart), 'minutes') >= timeToAdd){
                        slots.push({
                            session: session,
                            start: hourStart,
                            len: sessionMaxTime
                        })
                    }
               // }
        })


     //   console.log(slots);
        setSlots(slots)
    }

   const [slots, setSlots] = React.useState([]);

    const generateFreeSlots = () => {

        setASelectedSessionToAdd(null);

        if(admission?.procedures[0] && admission?.proceduresLen[0] !== 0) {
            let spec = admission.opType === "TCI"? admission?.procedures[0]?.specialty: null;

            API.getSessionsToAdd(moment().format("YYYY-MM-DD"),
                moment().add(1,"year").format("YYYY-MM-DD"), admission.opType, spec).then(sessions => {
                renderFreeSlots(sessions.__data);

            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);
            });

        } else {
            setSlots([])
        }

    }


    const [historyItems, setHistoryItems] = useState([]);

    useEffect(() => {
        if(props.operation || (operationId && operationId !== "new")) {
            setSlots([]);
            let id = props.operation?.id? props.operation?.id : operationId;
                API.getHistoryOperation(id).then(operations => {
                setHistoryItems(operations.reverse())

            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);
            });
        }

    },[props.operation, operationId]);


    const [selectedSessionToAdd, setASelectedSessionToAdd] = React.useState(null);

    const handleAddToSession = (slot) => {
        if(selectedSessionToAdd && selectedSessionToAdd.session === slot.session && selectedSessionToAdd.time === slot.start
            && selectedSessionToAdd.stationID === slot.stationID) {
            setASelectedSessionToAdd(null);
        } else {
            setAddToList(false)
            setASelectedSessionToAdd({
                session: slot.session,
                time: slot.start,
                stationID: slot.stationID
            })
        }
    }

    const [historyItemIndex, setHistoryItemIndex] = React.useState(null);

    const handleHistoryView = (direction) => {
        setHistoryItemIndex(historyItemIndex+direction);
    }

    useEffect(() => {
        if(historyView) {
            setAdmission({...historyItems[historyItemIndex]})
            document.getElementById("history_timeline_"+historyItemIndex)?.scrollIntoView({behavior: 'smooth', block: 'center'})
        }
    },[historyItemIndex])


    useEffect(() => {
        if(historyView) {
            setAdmissionTmp({...admission});
            setHistoryItemIndex(0);
            setDisabledFields(true);
        } else if(admissionTMP){
            setAdmission({...admissionTMP});
            setHistoryItemIndex(null);
            setDisabledFields(true);
        }
    },[historyView])

    const handleOpenPrintModal = () => {
        openPrintModal();
        const admissionWithPatient = {
            ...admission,
            patient: patientObject,
        };
        dispatch(setMarkedOperation(admissionWithPatient));
    }

    const handleClosePrintModal = () => {
        closePrintModal();
    }

    const [addToList, setAddToList] = React.useState(false)

    const userCanEditForm = () => {
        if(admission.patient === null) return false;

        if(admission.status === "WORKLIST")
            return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_T_ADMISSIONS, admission.opType));

        if(admissionViewTypes.THEATRES === admission.opType)
            return admission.bookedSession?
                    dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_T_TCI_SL, admission.opType)):
                    dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_TCI_UL, admission.opType));
        else
            return admission.bookedSession?
                    dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_ON_SL, admission.opType)):
                    (dispatch(hasOneOfPermission([Permissions.BA_CAN_MANAGE_MDU_UL, Permissions.BA_CAN_MANAGE_MDU_ADMISSIONS])) || dispatch(isBaAdmin(admission.opType)));
    }

    return (
        <Box>
            <Grid container>

                {!props.inCalendar && <Grid item xs={12} container className={classes.header}>
                    <Grid item xs={12} md={4} className={classes.headerLeft}>
                        {/*{!editView && <AgyleLogoIcon className={classes.appLogo}/>}*/}
                        {/*{!editView && <ArrowBackIcon className={classes.arrowIcon}/>}*/}
                        <div className={classes.patientName}>
                                <span className={classes.patientFamilyName}>
                                    {patientObject?.familyName}
                                </span>,&nbsp;
                            <span>
                                    {patientObject?.firstName}
                                </span>&nbsp;
                            <span>
                                    {patientObject?.middleNames}
                                </span>
                        </div>
                        {patientObject?.alerts && <PatientAlertsComponent patientObject={patientObject}/>}
                    </Grid>
                    <Grid item xs={12} md={8} className={classes.headerRight}>
                        {patientBadgeData &&
                            <div className={classes.patientBadge}>
                                {patientBadgeData}
                            </div>
                        }
                    </Grid>
                </Grid>
                }


                {historyView &&
                    <Box sx={{width: "calc(100vw - 410px)", display: "inline-flex"}} m={0}>
                    <div className={classes.historyViewBanner}>
                        <div className={classes.historyViewControls}>
                            <div className={classes.historyItemLength}> {historyItems.length} </div>
                            Edits
                        </div>

                        <div style={{display: "flex"}}>
                            <IconButton color="inherit" aria-label="expand"
                                        disabled={historyItemIndex < 1}
                                        component="label" onClick={() => {
                                handleHistoryView(-1)
                            }}>
                                <BackIcon />
                            </IconButton>
                            <IconButton color="inherit" aria-label="expand"
                                        disabled={historyItemIndex >= (historyItems.length - 1)}
                                        component="label"  onClick={()=>{handleHistoryView(1)}}>
                                <BackIcon style={{transform: "rotate(-180deg)"}}/>
                            </IconButton>
                        </div>
                    </div>

                    <div style={{ overflowX: "scroll", marginLeft: 10}} className={"scroll-normal-white"}>
                        <div style={{display: "inline-flex"}}>
                            {historyItems.map((item, index)=>{
                                return <div className={clsx(classes.historyItem, admission._id === item._id && "selected")}
                                            id={"history_timeline_"+index}
                                            onClick={()=>{setHistoryItemIndex(index)}}
                                          >
                                    <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                                        <div><b>{moment(item._lastModifiedDate).format("DD MMM, YYYY")}</b></div>
                                        <div>  {moment(item._lastModifiedDate).format("HH:mm")} </div>
                                    </div>

                                    <div style={{color: (admission._id === item._id? "#626466": "#ACAFB3"), fontSize: 13}}>
                                        by {item._lastModifiedBy}
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </Box>
                }

                {!historyView && <Grid item xs={12} container className={classes.subHeader} >
                     <Grid item xs={6} md={3} >
                         <div >
                             <div>
                                 {!props.inCalendar &&
                                 <IconButton color="inherit" aria-label="expand"
                                             disabled={iFrameView}
                                             component="label" onClick={() => goBack()}>
                                     <ArrowBackIcon sx={{width: "20px", height: "20px"}}/>
                                 </IconButton>
                                 }
                                 <div style={{
                                     paddingLeft: "8px",
                                     display: "inline-block",
                                     fontSize: "16px",
                                     position: "relative",
                                     fontWeight: 700,
                                     top: "4px"
                                 }}>
                                     {props.transfer ? "Transfer to TCI" : editView ? t("Admission") : t("Add New Admission")}
                                 </div>
                             </div>

                             <div style={{paddingLeft: "8px", fontSize: "12px", marginTop: "6px", whiteSpace: "nowrap"}}>
                                 <span>{t("Created by")}</span>
                                 &nbsp;
                                 <b>
                                     {admission._createdBy}
                                 </b>
                                 &nbsp;
                                 <span>{t("on")}</span>
                                 &nbsp;
                                 <b>{moment(admission._createdDate).format("DD/MM/YYYY HH:mm")}</b>
                             </div>

                             {/*{editView && <div*/}
                             {/*    style={{paddingLeft: "42px", fontSize: "0.75rem", marginTop: "-2px", whiteSpace: "nowrap"}}>*/}
                             {/*    <span>{t("Modified by")}</span>*/}
                             {/*    &nbsp;*/}
                             {/*    <span>*/}
                             {/*          <span>{admission._lastModifiedBy}</span>*/}
                             {/*    </span>*/}
                             {/*    &nbsp;*/}
                             {/*    <span>{t("on")}</span>*/}
                             {/*    &nbsp;*/}
                             {/*    <span>{moment(admission._lastModifiedDate).format("DD/MM/YYYY HH:mm")}</span>*/}
                             {/*</div>}*/}
                         </div>


                    </Grid>


                    <Grid item xs={12} md={9}>
                        <div style={{textAlign: "right"}}>
                            {admission.patientType && admission.patientType.hasOwnProperty("systype") && admission.patientType.systype === 'DC' &&
                                <Typography className={classes.dcLabel}>{t("Day Case")}</Typography>
                            }
                            {admission.patientType && admission.patientType.hasOwnProperty("systype") && admission.patientType.systype === 'IP' &&
                                <Typography className={classes.dcLabel}>{t("Inpatient")}</Typography>
                            }
                            {admission.opType && admission.opType !== "MDU" &&
                                <FormControl sx={{margin: "2px 10px", minWidth: 290}} size="small">
                                    <AdmissionConsultant
                                        name="AdmissionConsultant"
                                        label={"Overseeing Consultant"}
                                        color="primary"
                                        size={"small"}
                                        disableClearable
                                        disabled={(disableFields || !!admission.bookedSession)}
                                        value={admission.overseeingConsultant}
                                        onChange={(el) => {
                                            handleAdmissionChange("overseeingConsultant", el)
                                        }}
                                        placeholder={t("Type to see more records")}
                                    />
                                </FormControl>
                            }

                            {!editView &&
                            <AgyleToggleButtons
                                classNameRoot={baToggleClasses.baToggle_classNameRoot}
                                classNameLabel={baToggleClasses.baToggle_classNameLabel}
                                classNameSelected={baToggleClasses.baToggle_classNameSelected}
                                onChange={(e) => {
                                    handleAdmissionChangeType(e)

                                }}
                                value={_.find(itemsFormTypes, {code: admission.opType}) || itemsFormTypes[0]}
                                size="small"
                                disabled={disableFields}
                                options={itemsFormTypes}
                                minWidth={100}
                            />

                                // <ToggleRadioNamed items={itemsFormTypes}
                                //                             defaultItemSelected={_.find(itemsFormTypes, {code: admission.opType}) || itemsFormTypes[0]}
                                //                             sx={{top: "2px"}} btnWidth={"120px"}
                                //                             disabled={disableFields}
                                //                             onChange={(fType) => {
                                //                                 handleAdmissionChangeType(fType)
                                //                             }}/>
                            }

                            <ButtonGroup
                                disableElevation orientation={'horizontal'}
                                variant="contained" sx={{display: "inline"}}>

                                {editView  &&
                                    <Tooltip title={admission.patient === null? "MISSING PATIENT RECORD" : ""} placement="top">
                                        <span>
                                            <IconButton color="inherit" aria-label="expand"
                                                        disabled={!userCanEditForm()}
                                                        component="label" onClick={() => {setDisabledFields(!disableFields)}}>
                                                {disableFields ? <LockIcon/> : <LockOpenIcon/>}
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                }

                                <IconButton color="inherit" aria-label="expand"
                                            disabled={!editView}
                                            component="label"
                                            onClick={handleOpenPrintModal}>
                                    <PrintIcon/>
                                </IconButton>



                                {editView && !disableFields && <Button variant="outlined"
                                                                       sx={{margin: "0px 5px", borderRadius: "5px !important"}}
                                                                       onClick={reloadOperation}>
                                    {t("Discard Changes")}
                                </Button>
                                }
                                <Button variant="contained" endIcon={<SendIcon/>}
                                        disabled={disabledSave || disableFields}
                                        sx={{margin: "0px 5px", borderRadius: "5px !important"}} onClick={() => {
                                    handleSubmitAdmission()
                                }}>
                                    {editView ? t("Save") : t("Submit")}
                                </Button>


                            </ButtonGroup>
                        </div>
                    </Grid>

                </Grid> }



                <Box sx={{width: "100%"}} m={1}>
                    <AdmissionSection header={t("Demographics")} requiredLeft={0} defaultExpand={false}>
                        <FromDemographicsSection patient={patientObject} onChange={handleAdmissionChange}/>
                    </AdmissionSection>

                    {historyView &&
                        <AdmissionSection header={t("Overseeing Consultant")} requiredLeft={0} defaultExpand={false}>
                                 <Grid container>
                                    <Grid item xs={12}>{admission.overseeingConsultant?.name || "not set"}</Grid>
                                </Grid>
                        </AdmissionSection>
                    }
                    {admission.cancelInfo && !admission.bookedSession &&
                        <AdmissionSection header={t("Cancel Info")} requiredLeft={0} defaultExpand={true}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <FormControl sx={{width: "100%", marginRight: "10px"}}>
                                        <FormLabel id="procedure-notes-label"
                                                   className={inputClasses.label}>{t("Notes")}</FormLabel>
                                        <TextField
                                            aria-label="Notes"
                                            value={admission.cancelInfo.notes || ""}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{width: "100%", marginRight: "10px"}}>
                                        <FormLabel id="procedure-notes-label"
                                                   className={inputClasses.label}>{t("Who")}</FormLabel>
                                        <TextField
                                            aria-label="Who"
                                            value={admission.cancelInfo.who || ""}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{width: "100%", marginRight: "10px"}}>
                                        <FormLabel id="procedure-notes-label"
                                                   className={inputClasses.label}>{t("Date")}</FormLabel>
                                        <TextField
                                            aria-label="Date"
                                            value={moment(admission.cancelInfo.date).format("DD/MM/YYYY HH:mm") || ""}
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                        </AdmissionSection>
                    }
                    {admission.opType && admission.opType !== "MDU" &&
                    <React.Fragment>
                        <AdmissionSection header={t("Admission Basic Information")} requiredLeft={0} defaultExpand={true}>
                            <BasicInformationSection
                                admissionToEdit={admission}
                                disabled={disableFields}
                                isBooked = {!!admission.bookedSession}
                                dictionaries={dictionaries} onChange={handleAdmissionChange}/>
                        </AdmissionSection>
                        <AdmissionSection header={t("Procedures")} requiredLeft={0} defaultExpand={true}>
                            <FromProceduresSection disabled={disableFields}
                                                   onChange={handleProcedureChange} procedure={admission?.procedures}
                                                   procedureLen={admission?.proceduresLen} proceduresDict={procedures}
                                                   systype={admission.patientType?.systype}
                                                   overseeingConsultant={admission.overseeingConsultant}
                                                   isBooked = {!!admission.bookedSession}
                            />
                        </AdmissionSection>
                        <AdmissionSection header={t("Procedure Notes / Notes")} requiredLeft={0} defaultExpand={true}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <FormControl sx={{width: "100%", marginRight: "10px"}}>
                                        <FormLabel id="procedure-notes-label"
                                                   className={inputClasses.label}>{t("Procedure Notes")}</FormLabel>
                                        <AgyleTextField
                                            className={inputClasses.notesInput}
                                            aria-label="Procedure Notes"
                                            placeholder={t("Add text here")}
                                            value={admission.procedureNotes || ""}
                                            maxRows={10}
                                            minRows={10}
                                            disabled={disableFields}
                                            multiline
                                            debounce
                                            onChange={(e)=>{
                                                setAdmission((ad)=> {
                                                    return {
                                                        ...ad,
                                                        procedureNotes: e.target.value
                                                    }
                                                })
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl sx={{width: "100%", marginLeft: "10px"}}>
                                        <FormLabel id="op-notes-label" className={inputClasses.label}>{t("Notes")}</FormLabel>
                                        <AgyleTextField
                                            className={inputClasses.notesInput}
                                            aria-label="Notes"
                                            placeholder={t("Add text here")}
                                            value={admission.notes || ""}
                                            maxRows={10}
                                            disabled={disableFields}
                                            minRows={10}
                                            debounce
                                            onChange={(e)=>{
                                                setAdmission((ad)=> {
                                                    return {
                                                        ...ad,
                                                        notes: e.target.value
                                                    }
                                                })
                                            }}
                                            multiline
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </AdmissionSection>
                    </React.Fragment>
                    }
                    {admission.opType && admission.opType === "MDU" &&
                    <React.Fragment>
                        <AdmissionSection header={t("Main Procedure")} requiredLeft={0} defaultExpand={true}>
                            <ProcedureItem index={0}
                                           procedureMDU
                                           isBooked = {!!admission.bookedSession}
                                           disabled={disableFields}
                                           procedureItem={admission.procedures[0]}
                                           procedure={admission.procedures} procedureLen={admission.proceduresLen}
                                           proceduresDict={procedures} systype={admission.opType}
                                           onChange={handleProcedureChange}/>
                        </AdmissionSection>
                        <AdmissionSection header={t("Referral Notes")} requiredLeft={0} defaultExpand={true}>
                            <ReferralNotesSection disabled={disableFields}
                                                  admission={admission} onChange={handleAdmissionChange}/>
                        </AdmissionSection>
                        <AdmissionSection header={t("Clinical/Team Notes")} requiredLeft={0} defaultExpand={true}>
                            <ClinicalTeamNotesSection
                                admission={admission}
                                disabled={disableFields}
                                dictionaries={dictionaries} onChange={handleAdmissionChange}/>
                        </AdmissionSection>
                        <AdmissionSection header={t("Person Completing Record")} requiredLeft={0} defaultExpand={true}>
                            <Grid container >
                                <Grid item xs={4} sx={{paddingRight: "10px"}}>
                                    <FormControl sx={{width: "100%"}}>
                                        <FormLabel id="admission-person-completing-person-label" className={inputClasses.label}>{t("Name")}</FormLabel>
                                        <TextField id="admission-person-completing-person"
                                                   disabled={disableFields}
                                                   value={admission.personCompRecord?.personCompleting || ""}
                                                   onChange={(ev, t) => {handleAdmissionChange('personCompRecord.personCompleting', ev.target.value)}}/>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4} sx={{paddingRight: "10px"}}>
                                    <FormControl sx={{width: "100%"}}>
                                        <FormLabel id="admission-person-completing-role-label" className={inputClasses.label}>{t("Role")}</FormLabel>
                                        <Select
                                            labelId="admission-person-completing-role-label"
                                            id="admission-person-completing-role"
                                            disabled={disableFields}
                                            value={admission.personCompRecord?.role}
                                            onChange={(selected)=> {handleAdmissionChange('personCompRecord.role', selected.target.value)}}
                                        >
                                            <MenuItem value="" key="empty-option-person-completing-role">
                                                <em>None</em>
                                            </MenuItem>
                                            {dictionaries && dictionaries.role && dictionaries.role.map((r, index)=>{
                                                return (
                                                    <MenuItem value={r.description} key={index + "_" + r.code}>{r.description}</MenuItem>
                                                )                                            
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4} sx={{paddingRight: "10px"}}>
                                    <FormControl sx={{ width: "100%"}}>
                                        <FormLabel id="admission-person-completing-completed-on-label" className={inputClasses.label}>{t("Completed On")}</FormLabel>
                                        <DatePicker
                                            id="admission-person-completing-completed-on"
                                            disabled={disableFields}
                                            value={admission.personCompRecord?.recordCompleted}
                                            inputFormat={config.defaultDateFormat}
                                            onChange={(newValue) => {
                                                handleAdmissionChange('personCompRecord.recordCompleted', newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </AdmissionSection>
                    </React.Fragment>
                    }

                    {isPrintModalOpen &&
                      <HeaderPrintModal
                        title={"Print"}
                        open={isPrintModalOpen}
                        onClose={handleClosePrintModal}
                        width={"lg"}
                        fullWidth
                        fullScreen
                        disableActions
                        admissionType={admission.opType}
                        closeButtonOnHeader
                        onlyPatient
                      />}

                    {admission.bookedDate &&
                        <AdmissionSection header={t("Booked Session")} requiredLeft={0} defaultExpand={true}>
                            <div>Date and Time: {moment(admission.bookedDate).format("DD/MM/YYYY HH:mm")}</div>
                        </AdmissionSection>
                    }

                    {admission.endSurgery &&
                        <AdmissionSection header={t("End Surgery")} requiredLeft={0} defaultExpand={true}>
                            <div>Date and Time: {moment(admission.endSurgery).format("DD/MM/YYYY HH:mm")}</div>
                        </AdmissionSection>
                    }

                    {historyView &&
                        <AdmissionSection header={t("Decision History")} requiredLeft={0} defaultExpand={true}>
                            {admission.decisions?.map((decision)=>{
                                return <Grid container>
                                    <Grid item xs={3}>{moment(decision.date).format("DD/MM/YYYY HH:mm")}</Grid>
                                    <Grid item xs={2}>{decision.user}</Grid>
                                    <Grid item xs={3}>{decision.decision}</Grid>
                                    <Grid item xs={3}>{decision.status}</Grid>
                                </Grid>
                            })}
                        </AdmissionSection>
                    }
                    {historyView &&
                        <AdmissionSection header={t("Contact History")} requiredLeft={0} defaultExpand={true}>
                            {admission.contactHistory?.map((contact)=>{
                                return <Grid container>
                                    <Grid item xs={3}>{moment(contact.date).format("DD/MM/YYYY HH:mm")}</Grid>
                                    <Grid item xs={2}>{contact.user}</Grid>
                                    <Grid item xs={3}>{contact.source}</Grid>
                                    <Grid item xs={2}>{contact.type}</Grid>
                                    <Grid item xs={2}>{contact.status}</Grid>
                                </Grid>
                            })}
                        </AdmissionSection>
                    }

                    {!admission.bookedSession && !historyView && (!admission.cancelInfo || admission.cancelInfo.status === "rebook") &&
                        <AdmissionSection header={t("Schedule a surgery")} requiredLeft={0} defaultExpand={true}>

                            {admission.opType === "TCI" && <Grid container
                                                                 alignItems={"center"}
                                                                 justifyContent={"space-between"}
                                                                 className={classes.scheduleSlots}
                                                               >
                                <Grid item xs={6}> <b>Add to unscheduled list</b></Grid>

                                <Grid item xs={2} style={{
                                    display: "flex",
                                   justifyContent: "center"
                                }}>    {!props.inCalendar && admission.status !== "WORKLIST_AND_CALENDAR" &&
                                <AgyleButton
                                    size="small"
                                    className={classes.button}
                                    onClick={() => {
                                        if (addToList) {
                                            setAddToList(false)
                                        } else {
                                            setAddToList(true);
                                            setASelectedSessionToAdd(null);
                                        }
                                    }}
                                    startIcon={<PersonAddIcon/>}
                                    width="100px"
                                    disabled={disableFields}
                                    selected={addToList}
                                >
                                    Select
                                </AgyleButton>


                                }</Grid>
                            </Grid>
                            }


                            {slots?.map((slot) => {
                                return <Grid container
                                             alignItems={"center"}
                                             justifyContent={"space-between"}
                                             style={{
                                                 background: "#3D3E40",
                                                 margin: 5,
                                                 padding: 12,
                                                 borderRadius: 5
                                             }}>
                                    <Grid item xs={1}>{moment(slot.session.day).format("DD/MM/YYYY")}</Grid>
                                    <Grid item xs={2}>{slot.session.specialty?.__code}</Grid>
                                    <Grid item xs={2}>{slot.session.theatre?.description}</Grid>
                                    <Grid item xs={2}>{slot.session.consultant?.name}</Grid>
                                    <Grid item xs={2}>{moment(slot.start)?.format("HH:mm")}</Grid>
                                    {slot.stationID && <Grid item xs={1}>{slot.stationID}</Grid>}
                                    <Grid item xs={2}
                                          style={{
                                              display: "flex",
                                              justifyContent: "flex-end"
                                          }}
                                    > <AgyleButton
                                        size="small"
                                        className={classes.button}
                                        onClick={()=>handleAddToSession(slot)}
                                        startIcon={<PersonAddIcon/>}
                                        width="100px"
                                        disabled={disableFields}
                                        selected={selectedSessionToAdd &&
                                        slot.session.id === selectedSessionToAdd.session.id && slot.start === selectedSessionToAdd.time
                                        && slot.stationID === selectedSessionToAdd.stationID}
                                    >
                                        Select
                                    </AgyleButton></Grid>
                                </Grid>
                            })}

                        </AdmissionSection>
                    }


                </Box>
            </Grid>

        </Box>
    )
}
export default BookAdmissionForm;